export const DEFAULT_LIMIT = 25

export const PERIOD_OPTIONS = [
  { value: '1w', label: 'Última semana' },
  { value: '1m', label: 'Último mes' },
  { value: '2m', label: '2 meses' },
  { value: '6m', label: '6 meses' },
  { value: 'all', label: 'Histórico' }
]

export const ROLE_OPTIONS = [
  { value: 'driver', label: 'Conductor' },
  { value: 'companion', label: 'Acompañante' },
  { value: 'operator', label: 'Chofer' }
]

export const STATUS_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'active', label: 'Activos' },
  { value: 'suspended', label: 'Suspendidos' }
]

export const COLUMN_CONFIGS = {
  driver: [
    { key: 'user', label: 'Usuario' },
    { key: 'phone_number', label: 'Teléfono' },
    { key: 'role', label: 'Rol', sortKey: 'role' },
    { key: 'published', label: 'Viajes publicados', sortKey: 'published' },
    { key: 'completed', label: 'Viajes concretados', sortKey: 'completed' },
    { key: 'cancel_with_pax', label: 'Cancelaciones con reserva', sortKey: 'cancel_with_pax' },
    {
      key: 'cancel_without_pax',
      label: 'Cancelaciones sin reserva',
      sortKey: 'cancel_without_pax'
    },
    { key: 'expired_requests', label: 'Solicitudes expiradas', sortKey: 'expired_requests' },
    { key: 'rejected_requests', label: 'Solicitudes rechazadas', sortKey: 'rejected_requests' },
    { key: 'conversion', label: '% Concreción', sortKey: 'conversion' },
    { key: 'cancellation_rate', label: '% Cancelación', sortKey: 'cancellation_rate' },
    { key: 'rating', label: 'Puntuación promedio', sortKey: 'rating' },
    { key: 'km', label: 'Km realizados', sortKey: 'km' }
  ],
  companion: [
    { key: 'user', label: 'Usuario' },
    { key: 'phone_number', label: 'Teléfono' },
    { key: 'role', label: 'Rol', sortKey: 'role' },
    { key: 'purchases', label: 'Compras', sortKey: 'purchases' },
    { key: 'completed', label: 'Viajes completados', sortKey: 'completed' },
    { key: 'cancelled', label: 'Cancelados', sortKey: 'cancelled' },
    { key: 'abandonments', label: 'Abandonos', sortKey: 'abandonments' },
    { key: 'conversion', label: '% Conversión', sortKey: 'conversion' },
    { key: 'cancellation_rate', label: '% Cancelación', sortKey: 'cancellation_rate' },
    { key: 'abandonment_rate', label: '% Abandono', sortKey: 'abandonment_rate' },
    { key: 'rating', label: 'Puntuación promedio', sortKey: 'rating' },
    { key: 'km', label: 'Km realizados', sortKey: 'km' }
  ],
  operator: [
    { key: 'user', label: 'Usuario' },
    { key: 'phone_number', label: 'Teléfono' },
    { key: 'role', label: 'Rol', sortKey: 'role' },
    { key: 'published', label: 'Viajes publicados', sortKey: 'published' },
    { key: 'completed', label: 'Viajes concretados', sortKey: 'completed' },
    { key: 'cancel_with_pax', label: 'Cancelaciones con reserva', sortKey: 'cancel_with_pax' },
    {
      key: 'cancel_without_pax',
      label: 'Cancelaciones sin reserva',
      sortKey: 'cancel_without_pax'
    },
    { key: 'expired_requests', label: 'Solicitudes expiradas', sortKey: 'expired_requests' },
    { key: 'rejected_requests', label: 'Solicitudes rechazadas', sortKey: 'rejected_requests' },
    { key: 'conversion', label: '% Concreción', sortKey: 'conversion' },
    { key: 'cancellation_rate', label: '% Cancelación', sortKey: 'cancellation_rate' },
    { key: 'rating', label: 'Puntuación promedio', sortKey: 'rating' },
    { key: 'km', label: 'Km realizados', sortKey: 'km' }
  ]
}
